import request from '../utils/request';
import type {
  EmployeeDashboard,
  DatasetsResponse,
  UploadResponse,
  UploadTaskResponse,
  ConfirmUploadRequest,
  ConfirmUploadResponse,
  PhoneRecordsResponse,
  UploadTasksResponse,
  TaskDetailResponse,
  CreateManualEntryRequest,
  ManualEntryResponse,
  ManualEntriesResponse,
  ManualEntryStats,
} from '../types';

export const employeeService = {
  // 获取员工仪表板
  getDashboard: (): Promise<EmployeeDashboard> => {
    return request.get('/employee/dashboard');
  },

  // 获取数据集列表
  getDatasets: (): Promise<DatasetsResponse> => {
    return request.get('/employee/datasets');
  },

  // 任务式文件上传（新版本）
  uploadFileTask: (datasetId: number, file: File): Promise<UploadTaskResponse> => {
    const formData = new FormData();
    formData.append('dataset_id', datasetId.toString());
    formData.append('file', file);

    // 注意：不要手动设置 Content-Type，让浏览器自动设置 multipart/form-data 边界
    return request.post('/employee/upload', formData);
  },

  // 获取任务列表和上传记录（支持分页）
  getMyUploads: (params?: {
    page?: number;
    per_page?: number;
  }): Promise<UploadTasksResponse & { pagination?: any }> => {
    return request.get('/employee/my-uploads', { params });
  },

  // 获取任务详情
  getTaskDetail: (taskId: number): Promise<TaskDetailResponse> => {
    return request.get(`/employee/my-uploads/${taskId}`);
  },

  // 保持向后兼容的旧版本接口
  uploadFile: (datasetId: number, file: File): Promise<UploadResponse> => {
    const formData = new FormData();
    formData.append('dataset_id', datasetId.toString());
    formData.append('file', file);
    return request.post('/employee/upload', formData);
  },

  confirmUpload: (data: ConfirmUploadRequest): Promise<ConfirmUploadResponse> => {
    return request.post('/employee/confirm-upload', data);
  },

  // 手动入库相关API
  createManualEntry: (data: CreateManualEntryRequest): Promise<ManualEntryResponse> => {
    return request.post('/employee/manual-entry', data);
  },

  getManualEntries: (params?: {
    page?: number;
    per_page?: number;
    dataset_id?: number;
  }): Promise<ManualEntriesResponse> => {
    return request.get('/employee/manual-entries', { params });
  },

  getManualEntryStats: (): Promise<ManualEntryStats> => {
    return request.get('/employee/manual-entry-stats');
  },
};
